import { useEffect, useState } from 'react';
import { BasePick } from '../domain/types';
import { loadPlayerPhotos } from '../services/playerPhotos';

export function PlayerPhoto({ pick, className = '', fallbackLabel, preferPhoto = false }: { pick: BasePick; className?: string; showTeamBadge?: boolean; fallbackLabel?: string; preferPhoto?: boolean }) {
  const [images, setImages] = useState<{ photo?: string; teamLogo?: string }>();
  const [logoFailed, setLogoFailed] = useState(false);
  const [photoFailed, setPhotoFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    setImages(undefined);
    setLogoFailed(false);
    setPhotoFailed(false);
    void loadPlayerPhotos([pick]).then(result => { if (alive) setImages(result.get(pick.id)); });
    return () => { alive = false; };
  }, [pick.id, pick.player, pick.sport, pick.game]);
  const fallback = pick.sport === 'NBA' ? 'NBA' : 'NHL';
  const showLogo = Boolean(images?.teamLogo && !logoFailed);
  const image = preferPhoto && !photoFailed && images?.photo ? images.photo : showLogo ? images?.teamLogo : !photoFailed ? images?.photo : undefined;
  const showingPhoto = Boolean(image && images?.photo && image === images.photo && !photoFailed && (preferPhoto || !showLogo));
  const isTeamLogo = Boolean(image && image === images?.teamLogo && !showingPhoto);
  return <span className={`player-photo ${isTeamLogo || !image ? 'player-team-emblem' : 'player-portrait-fallback'} ${className}`} aria-label={`Imagem de ${pick.player}`}>
    {image
      ? <img className="player-photo-main" src={image} alt="" loading="lazy" decoding="async" onError={() => {
        if (showingPhoto) setPhotoFailed(true);
        else setLogoFailed(true);
      }} />
      : <span aria-hidden="true">{fallbackLabel ?? fallback}</span>}
  </span>;
}
